// Libraries
var React = require('react');

// Styles
require('./FixturesFilter.scss');

// Pollyfill
require('string.prototype.startswith');

class FixturesFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAutoComplete: false,
			teamNames: this.props.data.teamNames
		};

		this.seasons = this.props.data.seasons;

		document.querySelector('body').addEventListener('click', this.closeAutocomplete);
	}

	componentDidMount() {
		if (this.props.filtered) {
			this.props.onFilter();
		}
	}

	getCurrentSeason = () =>
		this.props.data.seasons.find(x => x.key === this.props.selectedSeasonId);

	handleCalendarClick = () => {
		const currentSeason = this.getCurrentSeason();
		if(currentSeason.addToCalendarLink.newWindow) {
			window.open(currentSeason.addToCalendarLink.url);
		} else {
			window.location.href = currentSeason.addToCalendarLink.url;
		}
	}

	handleDownloadClick = () => {
		window.open(this.getCurrentSeason().calendarImageDownloadUrl);
	}

	handleAutoComplete = (event) => {
		if(event.keyCode === 13 || event.target.value === '') {
			this.closeAutocomplete();
			this.props.onFilter();
		} else {
			this.setState({
				showAutoComplete: true,
				teamNames: this.props.data.teamNames.filter(teamName =>
					teamName
						.value
						.toLowerCase()
						.startsWith(event.target.value.toLowerCase())
				)
			});
		}
	}

	handleTeamNameClick = (item) => {
		document.querySelector('#teams').value = item.target.innerText;
		this.closeAutocomplete();
		this.props.onFilter();
	}

	closeAutocomplete = (event) => {
		this.setState({showAutoComplete: false });
	}

	render() {
		const competitions = this.props.data.competitions;
		const seasons = this.props.data.seasons;

		return (
			<div className="FixturesFilter">
				<div className="FixturesFilter__teams">
					<label htmlFor='teams' className="u-visually-hidden">Search Input</label>
					<input type="text" placeholder="Search by name" id="teams" onKeyUp={this.handleAutoComplete} ref={this.props.teamsRef} />
					<button onClick={this.props.onFilter} aria-label="Search"></button>

					<div className={"autocomplete" + (this.state.showAutoComplete ? " show" : "")}>
						<ul>
							{this.state.teamNames && this.state.teamNames.map(teamName =>
								<li id={teamName.key} key={teamName.key} onClick={this.handleTeamNameClick}>
									<button>{teamName.value}</button>
								</li>
							)}
						</ul>
					</div>
				</div>

				<div className="FixturesFilter__actions--mobile">
					<button className="FixturesFilter__actions--calendar" onClick={this.handleCalendarClick} aria-label="Open Calendar"></button>
				</div>

				<div className="wrapper">
					<div className="FixturesFilter__competitions">
						<select id="competitions" onChange={this.props.onFilter} ref={this.props.competitionsRef} defaultValue={competitions.find(a => a.selected).key}>
							{competitions && competitions.map((item, index) => 
								<option id={item.key} value={item.key} key={item.key}>{item.value.length > 13 ? (item.value.substring(0,13) + "...") : item.value}</option>
							)}
						</select>
					</div>
					<div className="FixturesFilter__seasons">
						<select id="seasons" onChange={this.props.onSeasonChange} ref={this.props.seasonsRef} defaultValue={seasons.find(a => a.selected).key}>
							{seasons && seasons.map((item, index) => (
								<option id={item.key} data-url={item.getFixturesApiUrl} key={item.key} value={item.key}>{item.value}</option>
							))}
						</select>
					</div>
					{this.props.filtered &&
						<div className="FixturesFilter__reset">
							<button onClick={this.props.onReset}>Reset</button>
						</div>
					}
				</div>

				<div className="FixturesFilter__actions--desktop">
					{seasons.some(s => s.addToCalendarLink !== null && s.selected) &&
						<button className="FixturesFilter__actions--calendar" onClick={this.handleCalendarClick} aria-label="Open calendar"></button>
					}
					{seasons.some(s => s.calendarImageDownloadUrl !== null && s.selected) &&
						<button className="FixturesFilter__actions--download" onClick={this.handleDownloadClick} aria-label="Download fixtures schedule"></button>
					}
				</div>
			</div>
		)
	};

	componentWillUnmount() {
		document.querySelector('body').removeEventListener('click', this.closeAutocomplete);
	}
}

module.exports = FixturesFilter;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixturesFilter.js